<template>
    <div class="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
        <div class="px-4 py-8 sm:px-10">
            <div>
                <p class="text-sm font-medium text-gray-700">
                    {{ __('Sign In') }}
                </p>

                <div class="mt-1 grid grid-cols-2 gap-3">
                    <div>
                        <a href="#" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                            <span class="sr-only">{{ __('Sign in with Twitter') }}</span>
                            <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                            </svg>
                        </a>
                    </div>
                    <div>
                        <a href="#" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                            <span class="sr-only">{{ __('Sign in with Google') }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" aria-hidden="true" fill="currentColor" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32"><path d="M16.318 13.714v5.484h9.078c-.37 2.354-2.745 6.901-9.078 6.901c-5.458 0-9.917-4.521-9.917-10.099s4.458-10.099 9.917-10.099c3.109 0 5.193 1.318 6.38 2.464l4.339-4.182C24.251 1.584 20.641.001 16.318.001c-8.844 0-16 7.151-16 16s7.156 16 16 16c9.234 0 15.365-6.49 15.365-15.635c0-1.052-.115-1.854-.255-2.651z" fill="currentColor"></path></svg>
                        </a>
                    </div>
                </div>
            </div>

            <div class="mt-6 relative">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-gray-300" />
                </div>
                <div class="relative flex justify-center text-sm">
                                      <span class="px-2 bg-white text-gray-500">
                                        {{ __('Or') }}
                                      </span>
                </div>
            </div>

            <div class="mt-6">
                <form class="space-y-4" @submit.prevent="$emit('submit')">
                    <div>
                        <label for="name" class="sr-only">{{ __('Username') }}</label>
                        <input type="text" name="name" id="name" autocomplete="name" placeholder="Full name" required="" class="block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm border-gray-300 rounded-md" />
                    </div>

                    <div>
                        <label for="mobile-or-email" class="sr-only">{{ __('E-Mail') }}</label>
                        <input type="text" name="mobile-or-email" id="mobile-or-email" autocomplete="email" placeholder="Mobile number or email" required="" class="block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm border-gray-300 rounded-md" />
                    </div>

                    <div>
                        <label for="password" class="sr-only">{{ __('Password') }}</label>
                        <input id="password" name="password" type="password" placeholder="Password" autocomplete="current-password" required="" class="block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm border-gray-300 rounded-md" />
                    </div>

                    <div>
                        <label for="confirm-password" class="sr-only">{{ __('Password Confirm') }}</label>
                        <input id="confirm-password" name="password" type="password" placeholder="Confirm Password" autocomplete="confirm-password" required="" class="block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm border-gray-300 rounded-md" />
                    </div>

                    <!--                                        <div>-->
                    <!--                                            <div class="mt-2 grid grid-cols-1 md:grid-cols-2 gap-4">-->
                    <!--                                                <label class="flex items-center">-->
                    <!--                                                    <checkbox v-model:checked=""/>-->
                    <!--                                                    <span class="ml-2 text-sm text-gray-600">{{ permission }}</span>-->
                    <!--                                                </label>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                        -->
                </form>
            </div>
        </div>
        <div class="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
            <button @click="$emit('submit')" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-500 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
                {{ __('Create your account') }}
            </button>
            <!--                                <p class="text-xs leading-5 text-gray-500">By signing up, you agree to our <a href="#" class="font-medium text-gray-900 hover:underline">Terms</a>, <a href="#" class="font-medium text-gray-900 hover:underline">Data Policy</a> and <a href="#" class="font-medium text-gray-900 hover:underline">Cookies Policy</a>.</p>-->
        </div>
    </div>
</template>

<script>
export default {
    name: "RegisterForm",
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                terms: false,
                policy: false,
            }),
            terms: this.__('<a target="_blank" href=":route" class="underline text-sm text-gray-600 hover:text-gray-900">:terms</a>', {
                terms: this.__('Terms of Service'),
                route: route('terms.show')
            }),
            privacy: this.__('<a target="_blank" href=":route" class="underline text-sm text-gray-600 hover:text-gray-900">:privacy</a>', {
                privacy: this.__('Privacy Policy'),
                route: route('policy.show')
            }),
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('register'), {
                onFinish: () => this.form.reset('password', 'password_confirmation'),
            })
        }
    }
}
</script>
